export default __webpack_public_path__ + "static/media/settings menu.77d85e4d.png";